@if (qaEnabled && !isUserPresenting) {
  <div class="raise-hand-container flex flex-column p-16">
    <span class="title weight-bold m-b-8">Q&#x26;A</span>
    <span class="info font-xs m-b-8"
      >Raise your hand to say something to the room. The moderator will call on you when they're ready.</span
    >
    @if (!isHandRaised) {
      <button mat-flat-button class="raise-hand-button" (click)="raiseHand()">Raise Your Hand</button>
    }
    @if (isHandRaised) {
      <button mat-flat-button class="raise-hand-button" (click)="lowerHand()">Lower Your Hand</button>
    }
  </div>
}
